// src/components/TopCurve/TopCurve.jsx
import { Box } from "@mui/material";

const TopCurve = () => {
  return (
    <Box
      component="svg"
      viewBox="0 0 630 202"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      sx={{
        position: "absolute",
        top: 0,
        // Inset from the left edge so the white blob floats.
        // Smaller on mobile so the blob hugs the left edge; full inset on desktop.
        left: { xs: 20, md: 70 },
        zIndex: 0,
        // Size in sx (real CSS) - NOT as top-level Box props, which MUI would
        // swallow as style shorthands and the svg would stretch to fill width.
        width: 630,
        height: 202,
        transformOrigin: "top left",
        // Legacy sizing: natural size on desktop, scaled down below 992px.
        transform: "scale(1)",
        "@media (min-width:768px) and (max-width:992px)": {
          transform: "scale(0.75)",
        },
        "@media (max-width:768px)": {
          transform: "scale(0.5)",
        },
      }}
    >
      <g filter="url(#filter0_d)">
        <path
          d="M86.5 171.5C0 130 2.58908e-06 57.5 0 3.45707e-06C269.5 1.28746e-05 621.759 -3.77378 617.5 3.45707e-06C376 214 173 213 86.5 171.5Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="-1.67723"
          width="629.538"
          height="202.899"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="8" dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </Box>
  );
};

export default TopCurve;
